
import SEO from '@/services/seo'
import Provider from '@/services/provider'
import gtm from '~/mixins/gtm'
import fetch from '~/mixins/fetch'
import { head } from '@/utils/head'
import { useApiService } from '~/services/api'

export default {
  mixins: [gtm, fetch],

  nuxtI18n: {
    parsePages: false,
    locales: ['pt-br', 'en', 'es'],
  },

  data() {
    return {
      gtmSubsection: 'Positions',
      gtmSubsection2: 'Job Description',

      position: {},

      locale: this.$i18n.locale,
      lang: this.$i18n.locale.slice(0, 2),
    }
  },

  fetchOnServer: true,

  async mounted() {
    try {
      await this.updateApiDb()

      await this.update()
    } catch (error) {
      this.$nuxt.error({ statusCode: 404, message: 'Page not found' })
    }
  },

  head() {
    if (this.hasFetchedPosition) {
      const { BASE_URL } = process.env

      const url = `${BASE_URL}${this.$route.path}`
      const i18nHead = this.$nuxtI18nHead({ addSeoAttributes: true })
      const lang = this.lang
      this.gtmInit(this.gtmSubsection, this.gtmSubsection2, this.position.title)
      this.gtmPush()
      const title = this.position.title
      const description = this.position.area ? this.position.area.body : ''
      const image = this.position.area?.image
        ? this.position.area.image
        : this.$t('seo.shared.image')
      const facebook = {
        image: this.position.area?.image
          ? this.position.area.image
          : this.$t('seo.shared.facebook.image'),
      }
      const twitter = {
        image: this.position.area?.image
          ? this.position.area.image
          : this.$t('seo.shared.twitter.image'),
      }

      return head({
        url,
        lang,
        title,
        description,
        image,
        canonical: url,
        facebook,
        twitter,
        htmlAttrs: { ...i18nHead.htmlAttrs },
        link: [],
        breadcrumbs: SEO.schema.breadcrumbs.getSchemaObj(this.breadcrumbs),
      })
    }
  },

  computed: {
    breadcrumbs() {
      const payload = {
        routePath: this.$route.path,
        dinamicValue: false,
      }

      const list = Provider.breadcrumbs.getItemList(payload)

      return list
    },
    hasFetchedPosition() {
      return Object.keys(this.position).length > 0
    },
  },

  methods: {
    gtmInit(subsection, subsection2, jobTitle) {
      this.defaultDataLayer.subsection = subsection
      this.defaultDataLayer.subsection2 = subsection2
      this.defaultDataLayer.jobTitle = jobTitle
      this.$gtm.init('GTM-M342BGM')
    },
    gtmPush() {
      this.$gtm.push({ ...this.defaultDataLayer })
    },

    async updateApiDb() {
      if (this.$route.query.update) {
        await useApiService({
          api: 'apiJobs',
          endpoint: 'jobs',
          url: `/sync`,
          method: 'post',
          data: {
            locale: [this.lang],
          },
        })
      }

      return
    },

    async update() {
      let result

      try {
        result = await useApiService({
          api: 'apiJobs',
          endpoint: 'jobs',
          url: `/find/${this.$route.params.id}`,
        })

        this.position = result
      } catch (error) {
        result = await useApiService({
          locale: this.lang,
          api: 'apiJobsExternalProvider',
          endpoint: 'jobs',
          url: `/${this.$route.params.id}`,
        })

        this.position = result
      }

      if (this.position) {
        return
      } else {
        this.$nuxt.error({
          statusCode: 404,
          message: 'This page could not be found',
        })
      }
    },
  },
}
